import ComicCard from '@/components/feature/ComicCard';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section id="latest" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-3">
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
              持续更新
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              及时同步热门韩漫最新话，不再错过精彩内容
            </p>
          </div>
          <a
            href="/category/romance"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {latestUpdates.slice(0, 10).map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}